import { VStack } from "@chakra-ui/react"
import React from "react"
import { GenerateZoneGroupRestrictedEntriesReportForm } from "../../../forms"

export const GenerateZoneGroupRestrictedEntriesReport: React.FC = () => {
	return (
		<VStack w="full" spacing={6}>
			<GenerateZoneGroupRestrictedEntriesReportForm />
		</VStack>
	)
}
